// extracted by mini-css-extract-plugin
export default {"biobar-tooltip":"styles_biobar-tooltip__ikYdB","biobar-tooltipText":"styles_biobar-tooltipText__REmXM"};